import { FormHelperText, Stack } from "@mui/material";
import FieldLabel from "components/FieldLabel";
import { LabelLink } from "components/FieldLabel/types";
import TextEditor, { type TextEditorBasicProps } from "components/TextEditor";
import { FieldValues, RegisterOptions, useController, useFormContext } from "react-hook-form";

interface TextEditorControlsProps extends TextEditorBasicProps {
  name: string;
  label?: string;
  labelLink?: LabelLink;
  hint?: string;
  rules?:
    | Omit<RegisterOptions<FieldValues, string>, "disabled" | "valueAsNumber" | "valueAsDate" | "setValueAs">
    | undefined;
}

const TextEditorControls = ({ name, label, labelLink, rules, disabled, hint, ...props }: TextEditorControlsProps) => {
  const { control } = useFormContext();

  const {
    field,
    fieldState: { invalid },
  } = useController({
    name,
    control,
    rules,
  });

  return (
    <Stack spacing={0.5}>
      {label && (
        <FieldLabel
          label={label}
          labelLink={labelLink}
          disabled={disabled}
          required={Boolean(rules?.required)}
        />
      )}
      <TextEditor
        value={field.value}
        onChange={field.onChange}
        isValid={!invalid}
        disabled={disabled}
        {...props}
      />
      {hint && <FormHelperText>{hint}</FormHelperText>}
    </Stack>
  );
};

export default TextEditorControls;
